import styles from './hint.module.scss';
import classNames from 'classnames';

export const Hint = ({ children, className }) => {
  return <p className={classNames(styles.Hint, className)}>{children}</p>;
};
